import React from "react";
import { useState } from "react";
import LayoutHOC from "../LayoutHOC";
import Input from "../UniversalComponents/InputComponent";
import Select from "../UniversalComponents/SelectComponent";
import DatePicker from "react-datepicker";
import { ReactComponent as CalendarWithTimeIcon } from "../../assets/images/calendarWithTimeIcon.svg";
import Button from "../UniversalComponents/DefaultButton";
import { Checkbox } from "@mui/material";
import CustomerHeaderHoc from "./CustomerHeaderHoc";
import TableComponent from "../UniversalComponents/TableComponent";

const Estimate = () => {
  const views = ["Edit", "Email View", "Payor View", "PDF View"];
  const [activeTab, setActiveTab] = useState(0);
  const [selectedValue, setSelectedValue] = useState("");
  const [email, setEmail] = useState("");
  const [billTo, setBillTo] = useState("");
  const [shipTo, setShipTo] = useState("");
  const [shipVia, setShipVia] = useState("");
  const [shippingDate, setShippingDate] = useState("");
  const [trackingNumber, setTrackingNumber] = useState("");
  const [estimatedNumber, setEstimatedNumber] = useState("");
  const [estimatedDate, setEstimatedDate] = useState("");
  const [acceptanceDate, setAcceptanceDate] = useState("");
  const [acceptanceBy, setAcceptanceBy] = useState("");
  const [selectedTagsValue, setSelectedTagsValue] = useState("");
  const [selected, setSelected] = useState([]);

  const selectOptions = [
    { value: "option1", label: "Option 1" },
    { value: "option2", label: "Option 2" },
    { value: "option3", label: "Option 3" },
  ];
  const selectTagOptions = [
    { value: "option1", label: "Option 1" },
    { value: "option2", label: "Option 2" },
    { value: "option3", label: "Option 3" },
  ];
  const optionData = ["Print and Download"];
  const handleSelectChange = (e) => {
    setSelectedValue(e.target.value);
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSelect = (option) => {
    setSelected(option);
  };
  const handleBillToChange = (e) => {
    setBillTo(e.target.value);
  };

  const handleShipToChange = (e) => {
    setShipTo(e.target.value);
  };

  const handleShipViaChange = (e) => {
    setShipVia(e.target.value);
  };

  const handleOnDateChange = (date) => {
    setShippingDate(date);
  };

  const handleTrackingNumberChange = (e) => {
    setTrackingNumber(e.target.value);
  };

  const handleEstimatedNumberChange = (e) => {
    setEstimatedNumber(e.target.value);
  };

  const handleEstimatedDateChange = (date) => {
    setEstimatedDate(date);
  };
  const handleAcceptanceDateChange = (date) => {
    setAcceptanceDate(date);
  };

  const handleAcceptanceByChange = (e) => {
    setAcceptanceBy(e.target.value);
  };

  const handleSelectedTagsChange = (e) => {
    setSelectedTagsValue(e.target.value);
  };
  return (
    <form className="mx-10">
      <div className="pb-2">
        <ul className="flex gap-5 text-[#848687] text-16 font-400 active:text-203C50">
          {views.map((item) => (
            <li
              key={item}
              onClick={() => setActiveTab(views.indexOf(item))}
              className={`cursor-pointer ${activeTab === views.indexOf(item) ? "text-[#203C50] font-500" : "text-[#848687] font-500"}`}
            >
              {item}
            </li>
          ))}
        </ul>
      </div>
      <div className="border rounded-[5px] border-[#1D446933] bg-white mb-4">
        <h4 className="text-18 text-[#434852] font-500 border-b border-[#BECBD3] px-5 py-2">Estimate</h4>
        <div className="px-5 py-2">
          <div className="flex justify-between">
            <div className="">
              <div>
                <h6 className="text-16 text-[#2C495D] font-500">GFPO USA</h6>
                <div className="text-[#5E5E5E] text-[15px] font-400">
                  <p>28228</p>
                  <p>gfpo.us@globalfpo.com</p>
                </div>
                <div>
                  <button className="mt-2">Edit Company component</button>
                </div>
              </div>
            </div>
            <div>Logo Here</div>
          </div>
          <div className="w-full">
            <div className="mt-2">
              <label className="text-14 text-[#434852] font-400">Add Customer</label>
              <div className="w-[25%]">
                <Select
                  placeholder={"Choose a option"}
                  options={selectOptions}
                  value={selectedValue}
                  onChange={handleSelectChange}
                  style={{ width: "100%", height: "35px", padding: "5px", color: "#AFAFAF", fontSize: "12px" }}
                />
              </div>
              {selectedValue && (
                <div className="w-full  mt-4 border rounded border-[#D6D3D3] bg-[#F5F5F5]">
                  <div className="border-b border-[#BECBD3]">
                    <div className=" p-2 px-3">
                      <label className="text-14 text-[#434852] font-400">Email</label>
                      <Input
                        placeholder="Enter Email"
                        name="email"
                        value={email}
                        onChange={handleEmailChange}
                        style={{ width: "25%", height: "35px", padding: "5px" }}
                      />
                      <label className="text-009CBF text-12 font-400">Cc/Bcc</label>
                    </div>
                  </div>
                  <div className="p-2 px-3">
                    <div className="space-x-2 flex  justify-between w-full">
                      <div className="w-full">
                        <label className="text-14 text-[#434852] font-400">Bill to</label>
                        <Input
                          placeholder="Enter Details"
                          name="Bill to"
                          value={billTo}
                          onChange={handleBillToChange}
                          style={{ width: "100%", height: "35px", padding: "5px" }}
                        />
                      </div>
                      <div className="w-full">
                        <label className="text-14 text-[#434852] font-400">Ship to</label>
                        <Input
                          placeholder="Enter Details"
                          name="Ship to"
                          value={shipTo}
                          onChange={handleShipToChange}
                          style={{ width: "100%", height: "35px", padding: "5px" }}
                        />
                      </div>
                      <div className="w-full">
                        <label className="text-14 text-[#434852] font-400">Ship Via</label>
                        <Input
                          placeholder="Enter Details"
                          name="Ship via"
                          value={shipVia}
                          onChange={handleShipViaChange}
                          style={{ width: "100%", height: "35px", padding: "5px" }}
                        />
                      </div>
                      <div className="w-full">
                        <label className="w-full text-14 text-434852 font-400 pb-1 ">Shipping date</label>
                        <div className="flex items-center bg-white  datePicker_container rounded">
                          <DatePicker
                            selected={shippingDate}
                            onChange={handleOnDateChange}
                            placeholderText={"DD/MM/YYYY"}
                            dateFormat={"dd/MM/yyyy"}
                            className="bg-white border-[#DFE2E5]  w-[100%]   text-gray-800 text-sm block h-[35px] rounded "
                          />

                          <div>
                            <CalendarWithTimeIcon />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="space-x-2 flex  justify-between w-full mt-2">
                      <div className="w-full">
                        <label className="text-14 text-[#434852] font-400">Tracking Number</label>
                        <Input
                          placeholder="Enter Details"
                          name="Tracking Number"
                          value={trackingNumber}
                          onChange={handleTrackingNumberChange}
                          style={{ width: "100%", height: "35px", padding: "5px" }}
                        />
                      </div>
                      <div className="w-full">
                        <label className="text-14 text-[#434852] font-400">Estimate Number</label>
                        <Input
                          placeholder="Enter Details"
                          name="Estimate Number"
                          value={estimatedNumber}
                          onChange={handleEstimatedNumberChange}
                          style={{ width: "100%", height: "35px", padding: "5px" }}
                        />
                      </div>
                      <div className="w-full">
                        <label className="w-full text-14 text-434852 font-400 pb-1 ">Estimate date</label>
                        <div className="flex items-center bg-white  datePicker_container rounded">
                          <DatePicker
                            selected={estimatedDate}
                            onChange={handleEstimatedDateChange}
                            placeholderText={"DD/MM/YYYY"}
                            dateFormat={"dd/MM/yyyy"}
                            className="bg-white border-[#DFE2E5]  w-[100%]   text-gray-800 text-sm block h-[35px] rounded "
                          />

                          <div>
                            <CalendarWithTimeIcon />
                          </div>
                        </div>
                      </div>
                      <div className="w-full">
                        <label className="text-14 text-[#434852] font-400">Acceptance by</label>
                        <Input
                          placeholder="Enter Details"
                          name="Acceptance by"
                          value={acceptanceBy}
                          onChange={handleAcceptanceByChange}
                          style={{ width: "100%", height: "35px", padding: "5px" }}
                        />
                      </div>
                    </div>
                    <div>
                      <div className="w-[24.5%] mt-2">
                        <label className=" text-14 text-434852 font-400 pb-1 ">Acceptance Date</label>
                        <div className="flex items-center bg-white  datePicker_container rounded">
                          <DatePicker
                            selected={acceptanceDate}
                            onChange={handleAcceptanceDateChange}
                            placeholderText={"DD/MM/YYYY"}
                            dateFormat={"dd/MM/yyyy"}
                            className="bg-white border-[#DFE2E5]  w-[100%]   text-gray-800 text-sm block h-[35px] rounded "
                          />

                          <div>
                            <CalendarWithTimeIcon />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="mt-1">
              <label className="text-14 text-[#434852] font-400">Tags</label>
              <div className="w-[25%]">
                <Select
                  placeholder={"Choose a option"}
                  options={selectTagOptions}
                  value={selectedTagsValue}
                  onChange={handleSelectedTagsChange}
                  style={{ width: "100%", height: "35px", padding: "5px", color: "#AFAFAF", fontSize: "12px" }}
                />
              </div>
              <label className=" text-12 text-[#009CBF] font-400 pb-1 pe-1">Manage Tags</label>
            </div>
          </div>
        </div>
      </div>
      <div>
        <TableComponent name="itemDetails" />
      </div>
      <div className="   border bg-white p-4 border-[#D6D3D3] mt-4 rounded">
        <div className="flex gap-4 w-[100%]">
          <div className="w-full">
            <label className="text-434852 font-400 text-14">
              Activate online card or bank transfer payments for your clients
            </label>
            <div className="border border-[#D6D3D3] h-32 rounded-md"></div>
          </div>
          <div className="w-full">
            <label className="text-434852 font-400 text-14">Note to customer</label>
            <div className="border border-[#D6D3D3] h-32 rounded-md"></div>
          </div>
          <div className="w-full">
            <label className="text-434852 font-400 text-14">Note to customer</label>
            <div className="border border-[#D6D3D3] h-32 rounded-md"></div>
          </div>
        </div>

        <div className=" flex gap-4 w-[66%] pt-2">
          <div className="w-full">
            <label className="flex justify-between">
              <label className="text-14 text-434852 font-400 pb-1 ">
                <span className="font-600">Attachments(0)</span> Maximum Size 20 MB
              </label>
            </label>
            <div className="flex items-center justify-center rounded-md border-[#DFE2E5] border h-32 w-[100%]">
              <div className="flex flex-col items-center">
                <label className="text-[#AFAFAF] text-12 font-400 text-center">
                  Drop files here or click to select from the device
                </label>
                <div className="text-12">Upload from this device </div>
              </div>
            </div>
            <label className=" text-12 text-[#009CBF] font-400 pb-1 pe-1">Show existing</label>
          </div>

          <div className="w-full mt-6 border border-[#D6D3D3] h-32 rounded-md">
            <div className="border-b-2 pl-2 ">
              <label className="text-434852 font-400 text-14 ">Uploaded Files</label>
            </div>
          </div>
        </div>
      </div>
      <div className="flex justify-end w-full mt-4">
        <div className="border bg-[#F6FEFF] h-full w-1/4">
          <div className=" my-2 text-12">
            <div className=" border-b p-1 px-6">
              <div className="flex justify-between  items-center">
                <label className="text-1D4469   font-400">Sub Total</label>
                <span className="text-383838 font-500">$ 123.00</span>
              </div>
            </div>
            <div className="border-b items-center w-full text-12">
              <div className="flex flex-wrap justify-between px-4 md:px-6 items-center">
                <div className="flex flex-wrap space-y-0 md:space-y-0 md:space-x-3 w-full md:w-auto">
                  <div className="flex cursor-pointer items-center space-x-1">
                    <Checkbox
                      checked={selected === "percent"}
                      icon={<i className="bi bi-circle text-lg"></i>}
                      checkedIcon={<i className="bi bi-record-circle text-lg"></i>}
                      sx={{ padding: 0, height: "auto" }}
                      onChange={() => handleSelect("percent")}
                    />
                    <span className="text-[#1D4469] font-[400] text-12 md:text-base">Discount Percent</span>
                  </div>
                  <div className="flex cursor-pointer items-center space-x-1">
                    <Checkbox
                      checked={selected === "value"}
                      icon={<i className="bi bi-circle text-lg"></i>}
                      checkedIcon={<i className="bi bi-record-circle text-lg"></i>}
                      sx={{ padding: 0, height: "auto" }}
                      onChange={() => handleSelect("value")}
                    />
                    <span className="text-[#1D4469] font-[400] text-12 md:text-base">Discount Value</span>
                  </div>
                </div>

                <span className="text-[#383838] font-[500] whitespace-nowrap text-12 md:text-base">$ 123.00</span>
              </div>
            </div>

            <div className=" border-b p-2 px-6">
              <div className="flex justify-between  items-center">
                <label className="text-1D4469   font-400">Shipping</label>
                <span className="text-383838 font-500">$ 123.00</span>
              </div>
            </div>
            <div className=" border-b p-2 px-6">
              <div className="flex justify-between  items-center">
                <label className="text-1D4469   font-400">Total</label>
                <span className="text-383838 font-500">$ 123.00</span>
              </div>
            </div>
            <div className=" p-2 px-6">
              <div className="flex justify-between  items-center">
                <label className="text-1D4469   font-400">Total Credit</label>
                <span className="text-383838 font-500">$ 123.00</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex justify-between py-3 items-center mb-20 ">
        <div className="">
          <ul className="flex space-x-3  text-[#009CBF] text-12 font-400">
            {optionData.map((option) => (
              <li key={option}>{option}</li>
            ))}
          </ul>
        </div>

        <div className="flex  space-x-2 ">
          <Button type="primary" onClick={""} style={{ color: "#535252", height: "35px" }}>
            CANCEL
          </Button>
          <Button type="secondary" onClick={""} style={{ height: "35px" }}>
            SAVE
          </Button>
        </div>
      </div>
    </form>
  );
};

export default LayoutHOC(CustomerHeaderHoc(Estimate));
